import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FundViewOutlinedSvg from "@ant-design/icons-svg/es/asn/FundViewOutlined";
import AntdIcon from '../components/AntdIcon';
var FundViewOutlined = function FundViewOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: FundViewOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(FundViewOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'FundViewOutlined';
}
export default RefIcon;